var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.2V21.8C22.5 21.9857 22.4263 22.1637 22.295 22.295C22.1637 22.4263 21.9857 22.5 21.8 22.5H2.2C2.01435 22.5 1.8363 22.4263 1.70503 22.295C1.57375 22.1637 1.5 21.9857 1.5 21.8V2.2C1.5 2.01435 1.57375 1.8363 1.70503 1.70503C1.8363 1.57375 2.01435 1.5 2.2 1.5H21.8C21.9857 1.5 22.1637 1.57375 22.295 1.70503C22.4263 1.8363 22.5 2.01435 22.5 2.2V2.2Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5291 7.36328H9.75415M15.5291 7.36328V13.1383M15.5291 7.36328L11.405 11.4886C8.51748 14.3761 11.405 17.2636 11.405 17.2636",
    stroke: "#5B5B5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortcut);
export default __webpack_public_path__ + "static/media/shortcut.7554c52d2d28924aa59a329297508ec7.svg";
export { ForwardRef as ReactComponent };